"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattentParentBlocks = (block) => {
    //   const pb = block.parentBlock;
    return block.parentBlock;
};
//# sourceMappingURL=flattentParentBlocks.js.map